import Swiper from 'swiper';

const defaultOptions = {
    navigation: {
        prevEl: '.js-slider-arrows-previous',
        nextEl: '.js-slider-arrows-next',
        disabledClass: 'slider-arrows__arrow--disabled',
    },
    slidesPerView: 1,
};

/**
 * Slider
 */
export default class Slider {
    constructor(element, options = defaultOptions) {
        this.element = element;
        this.options = options;
        this.swiper = new Swiper(this.element, {...this.options});

        this.blurArrowButtons();
    }

    blurArrowButtons() {
        [
            document.querySelector(this.options.navigation.prevEl),
            document.querySelector(this.options.navigation.nextEl),
        ].forEach((arrowElement) => {
            arrowElement.addEventListener('click', (e) => e.currentTarget.blur());
        });
    }
}
